var map = {
	"./auto.svg": "3fd2",
	"./bicycle-picture.svg": "d40b",
	"./budget.svg": "738e",
	"./car-coverage.svg": "4fdb",
	"./car-picture.svg": "e1de",
	"./car.svg": "8e4c",
	"./card+.svg": "5c24",
	"./card-bus.svg": "3033",
	"./card.svg": "4a7c",
	"./cost-repair.svg": "14ac",
	"./coverage.svg": "e20c",
	"./firm.svg": "aca6",
	"./green-card.svg": "66ec",
	"./medical.svg": "8379",
	"./mono-picture.svg": "2087",
	"./moto-coverage.svg": "d274",
	"./moto-picture.svg": "85c7",
	"./motocycle.svg": "80b1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f038";